const uint8ArrayWireType = 'Uint8Array';
const wireTypeKey = '__alttvisionWireType';

type WireEncodedUint8Array = {
  [wireTypeKey]: typeof uint8ArrayWireType;
  data: number[];
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value && typeof value === 'object' && !Array.isArray(value));
}

function isEncodedUint8Array(value: unknown): value is WireEncodedUint8Array {
  return (
    isRecord(value) &&
    value[wireTypeKey] === uint8ArrayWireType &&
    Array.isArray(value.data) &&
    value.data.every((entry) => Number.isInteger(entry) && entry >= 0 && entry <= 255)
  );
}

export function encodeIpcWireValue(value: unknown): unknown {
  if (value instanceof Uint8Array) {
    return {
      [wireTypeKey]: uint8ArrayWireType,
      data: Array.from(value)
    };
  }

  if (Array.isArray(value)) {
    return value.map((entry) => encodeIpcWireValue(entry));
  }

  if (isRecord(value)) {
    return Object.fromEntries(
      Object.entries(value)
        .filter(([, entry]) => entry !== undefined)
        .map(([key, entry]) => [key, encodeIpcWireValue(entry)])
    );
  }

  return value;
}

export function decodeIpcWireValue(value: unknown): unknown {
  if (isEncodedUint8Array(value)) {
    return new Uint8Array(value.data);
  }

  if (Array.isArray(value)) {
    return value.map((entry) => decodeIpcWireValue(entry));
  }

  if (isRecord(value)) {
    return Object.fromEntries(Object.entries(value).map(([key, entry]) => [key, decodeIpcWireValue(entry)]));
  }

  return value;
}
